import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { InputMi } from '@design-system-etat/dsfr-react';
import { getDateFormatWithSlash } from 'components/Commun/Form/maskFunctions';
import REGEXP_DATE_FR from './regex';

const DateInput = ({ name, required, error, noFuture, label, disabled, valid, validate }) => {
    const { formState, register } = useFormContext();

    const checkNoFuture = (valeur) => {
        if (valeur && noFuture) {
            const dateDecoupee = valeur.split('/');
            if (
                new Date(dateDecoupee[2], dateDecoupee[1] - 1, dateDecoupee[0]).getTime() >=
                new Date().getTime()
            ) {
                return 'La date renseignée ne doit pas être supérieure à la date du jour';
            }
        }

        return true;
    };

    const checkFormat = (valeur) => {
        if (!valeur || (valeur && valeur.length === 10 && REGEXP_DATE_FR.exec(valeur))) {
            return true;
        }

        return 'Le format est incorrect';
    };

    const validateRegister = {
        validateFormat: checkFormat,
        noFuture: checkNoFuture,
        ...validate,
    };

    return (
        <InputMi
            name={name}
            label={label}
            placeholder="JJ/MM/AAAA"
            maskFonction={getDateFormatWithSlash}
            {...register(name, {
                required: required ? 'Ce champs est requis' : null,
                validate: validateRegister,
            })}
            required={required}
            error={formState.errors ? formState.errors[name] : error}
            disabled={disabled}
            valid={valid}
        />
    );
};

DateInput.propTypes = {
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    error: PropTypes.oneOfType([
        PropTypes.shape({
            message: PropTypes.string,
        }),
        PropTypes.bool,
    ]),
    /** custom validate de React Hook Form */
    validate: PropTypes.shape({}),
    noFuture: PropTypes.bool,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    valid: PropTypes.oneOfType([
        PropTypes.shape({
            message: PropTypes.string,
        }),
        PropTypes.bool,
    ]),
};

export default DateInput;
